import { AngularMaterialModule } from './modules/angular-material.module';
import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './components/button/button.component';
import { IconModule } from './modules/icon/icon.module';
import { AgGridModule } from 'ag-grid-angular';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { ExportBoxComponent } from './components/export-box/export-box.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { CustomDatepickerHeaderComponent } from './components/month-picker/custom-datepicker-header.component';
import { StatusCellComponent } from './components/status-cell/status-cell.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridFormArrayDirective } from './directives/ag-grid-form-array.directive';
import { SearchAndCheckboxFilterComponent } from '@app/shared/components/ag-filters/search-and-checkbox-filter/search-and-checkbox-filter.component';
import { CheckboxFilterComponent } from '@app/shared/components/ag-filters/checkbox-filter/checkbox-filter.component';
import { AppDateFormatDirective, AppDateSelectedMonthDirective } from '@app/shared/classes/app-date-adapter';
import { RadioAndDatepickerFilterComponent } from '@app/shared/components/ag-filters/radio-and-datepicker-filter/radio-and-datepicker-filter.component';
import { InformationModalComponent } from './components/information-modal/information-modal.component';

const ANGULAR_MODULES: Type<any>[] = [FormsModule, ReactiveFormsModule];

@NgModule({
  declarations: [
    ButtonComponent,
    ConfirmModalComponent,
    InformationModalComponent,
    MonthPickerComponent,
    CustomDatepickerHeaderComponent,
    ExportBoxComponent,
    StatusCellComponent,
    SearchAndCheckboxFilterComponent,
    CheckboxFilterComponent,
    AppDateFormatDirective,
    AppDateSelectedMonthDirective,
    RadioAndDatepickerFilterComponent,
    AgGridFormArrayDirective
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    IconModule,
    AgGridModule.withComponents(),
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    AngularMaterialModule,
    ButtonComponent,
    IconModule,
    AgGridModule,
    MonthPickerComponent,
    ExportBoxComponent,
    StatusCellComponent,
    ...ANGULAR_MODULES,
    AgGridFormArrayDirective,
    AppDateFormatDirective,
    AppDateSelectedMonthDirective
  ]
})
export class SharedModule {}
